import React, {useEffect, useState, useRef} from "react";
import {ADOBEDTM_PAGE_NAME} from "../../constants";
import {API, processApiResponse} from "../../services/HttpHandler";
import {
  // dataDashboard,
  checkContentAvlInArray,
} from "../../util";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import CancelConfirmBox from "../../components/CancelPopUp";
import BlockBtn from "../../components/BlockBtn";
import AgendamientoAppointment from "../../components/AgendamientoAppointment";
import Loader from "../../components/Loader";
import TabsMenu from "../../components/TabsMenu";
import {
  setCustomerSlotDetails,
  getCustomerSlotDetails,
} from "../../services/SessionStorage";
import config from "config";

import "./style.scss";
import "../../components/Loader/style.scss";

const StoreAppointments = () => {
  const [currentAppointment, setCurrentAppn] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openCancelConfirm, setOpenCancelConfirm] = useState(false);
  const {t} = useTranslation();
  const navigate = useNavigate();
  const updatedCustomerSlotDetails = useRef(getCustomerSlotDetails());
  const performAction = () => {
    if (
      checkContentAvlInArray(
        config.stand_alone_bu_list,
        updatedCustomerSlotDetails.current.buList
      )
    ) {
      navigate("/customer/selectMallStore");
    } else {
      navigate("/customer/selectStore");
    }
  };
  const fetchUserLatestBookingPBU = async () => {
    try {
      setLoading(true);
      const current = updatedCustomerSlotDetails.current;
      updatedCustomerSlotDetails.current.existingBookingDetails = null;
      const prepareURL = `?country=${current.country}`;
      const url =
        `${config.endPoints.perBuBookings}/${current.userId}` + prepareURL;
      let response = await API.get(url);
      response = await processApiResponse(response);
      if (response.length && response.length > 0) {
        const currentAppointments = response.map((r) =>
          Object.values(r)
            .flat()
            .filter((a) => a.status !== "expired")
        );

        updatedCustomerSlotDetails.current.existingBookingDetails =
          currentAppointments;

        setCustomerSlotDetails(updatedCustomerSlotDetails.current);
        return true;
      }
      return false;
    } catch (errorMessage) {
      return false;
    } finally {
      setLoading(false);
    }
  };

  const agreeCancel = () => {
    let cancelInfo = {
      bookingId: currentAppointment.uuid,
      userId: currentAppointment.userId,
    };
    updatedCustomerSlotDetails.current.cancelDetail = cancelInfo;
    setCustomerSlotDetails(updatedCustomerSlotDetails.current);
    setCurrentAppn(null);
    navigate("/customer/cancelAppointments");
  };

  const cancelConfirm = () => {
    // const datamap = new Map();
    // datamap.set("events", "event17=1");
    // dataDashboard(datamap);
    setOpenCancelConfirm(true);
  };

  useEffect(() => {
    // const URL = window.location.href.split("/")[2];
    // const datamap = new Map();
    // datamap.set("pageName", ADOBEDTM_PAGE_NAME.CT_Display_Bookings);
    // datamap.set("prop1", URL);
    // datamap.set("prop2", URL + "/app");
    // dataDashboard(datamap);
    fetchUserLatestBookingPBU();
  }, []);

  const cancelAction = (appointment) => {
    setCurrentAppn(appointment);
    cancelConfirm();
  };

  const showMoreInfo = (appointment) => {
    setCurrentAppn(appointment);
    updatedCustomerSlotDetails.current.appointmentuuid = appointment.uuid;
    setCustomerSlotDetails(updatedCustomerSlotDetails.current);
    navigate("/customer/currentBooking");
  };

  const undoCancel = () => {
    setOpenCancelConfirm(false);
    setCurrentAppn(null);
  };

  if (loading) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  }
  return (
    <>
      <TabsMenu path="displayAppointments" />
      <div className="main-container">
        <AgendamientoAppointment
          appointmentsDetails={updatedCustomerSlotDetails.current}
          menuHandler={cancelAction}
          linkHandler={showMoreInfo}
        />
        {openCancelConfirm && (
          <CancelConfirmBox
            title={t("cancel.reservation.title")}
            storeName={currentAppointment.storeName}
            close={() => undoCancel()}
            performAction={() => agreeCancel()}
            isOffice={false}
          />
        )}
        <div className="displayAppointment-footer">
          <BlockBtn
            name={t("login.label")}
            handleClick={performAction}
            disabled={false}
          />
        </div>
      </div>
    </>
  );
};

export default StoreAppointments;
